import * as React from "react";
const IconControlPanelAlt = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M56 7.2H8c-2.8 0-5 2.2-5 5v39.6c0 2.8 2.2 5 5 5h48c2.8 0 5-2.2 5-5V12.2c0-2.7-2.2-5-5-5m3 44.6c0 1.7-1.3 3-3 3H8c-1.7 0-3-1.3-3-3V12.2c0-1.7 1.3-3 3-3h48c1.7 0 3 1.3 3 3z" />
    <path d="M17.7 19.6v-4.2c0-.6-.4-1-1-1s-1 .4-1 1v4.2c-2.6.5-4.5 2.7-4.5 5.4s1.9 4.9 4.5 5.4v18.3c0 .6.4 1 1 1s1-.4 1-1V30.4c2.6-.5 4.5-2.7 4.5-5.4s-1.9-4.9-4.5-5.4m-1 8.9c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5M33 35V15.4c0-.6-.4-1-1-1s-1 .4-1 1V35c-2.6.5-4.5 2.7-4.5 5.4s1.9 4.9 4.5 5.4v2.8c0 .6.4 1 1 1s1-.4 1-1v-2.8c2.6-.5 4.5-2.7 4.5-5.4S35.6 35.5 33 35m-1 8.9c-2 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5M48.3 21.2v-5.8c0-.6-.4-1-1-1s-1 .4-1 1v5.8c-2.6.5-4.5 2.7-4.5 5.4s1.9 4.9 4.5 5.4v16.6c0 .6.4 1 1 1s1-.4 1-1V32c2.6-.5 4.5-2.7 4.5-5.4s-1.9-4.9-4.5-5.4m-1 8.9c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5c0 2-1.6 3.5-3.5 3.5" />
  </svg>
);
export default IconControlPanelAlt;
